import { Accordion, Group, SegmentedControl, Text } from "@mantine/core";
import { useMemo, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import ResellersMessagesItem from "./ResellersMessagesItem";
import { IconMessage } from "@tabler/icons-react";

const ResellerMessages = () => {
  const lang = useLanguage((s) => s.language);

  const [active, setActive] = useState("InviteUserOrganization");
  const names = useMemo(() => {
    return [
      {
        value: "InviteUserOrganization",
        label: lang.resellers.messages.names.InviteUserOrganization,
      },
      {
        value: "InviteUserTeam",
        label: lang.resellers.messages.names.InviteUserTeam,
      },
      {
        value: "OrganizationJoin",
        label: lang.resellers.messages.names.OrganizationJoin,
      },
      {
        value: "TeamJoin",
        label: lang.resellers.messages.names.TeamJoin,
      },
      {
        value: "LinkedinDisconnected",
        label: lang.resellers.messages.names.LinkedinDisconnected,
      },
      {
        value: "MailDisconnectedAPIEmailAccount",
        label: lang.resellers.messages.names.MailDisconnectedAPIEmailAccount,
      },
      {
        value: "MailTestSmtpCredentials",
        label: lang.resellers.messages.names.MailTestSmtpCredentials,
      },
      {
        value: "MailValidationMail",
        label: lang.resellers.messages.names.MailValidationMail,
      },
      {
        value: "MailValidationMassMailing",
        label: lang.resellers.messages.names.MailValidationMassMailing,
      },
      {
        value: "PasswordResetEmail",
        label: lang.resellers.messages.names.PasswordResetEmail,
      },
      {
        value: "AccountLocked",
        label: lang.resellers.messages.names.AccountLocked,
      },
      {
        value: "PositiveReply",
        label: lang.resellers.messages.names.PositiveReply,
      },
      {
        value: "NegativeReply",
        label: lang.resellers.messages.names.NegativeReply,
      },
      {
        value: "NeutralReply",
        label: lang.resellers.messages.names.NeutralReply,
      },
      {
        value: "PrmColumnEntryInstant",
        label: lang.resellers.messages.names.PrmColumnEntryInstant,
      },
      {
        value: "PrmColumnEntryDailyDigest",
        label: lang.resellers.messages.names.PrmColumnEntryDailyDigest,
      },
    ];
  }, [lang.resellers]);

  return (
    <Accordion variant="filled" mt={"md"} radius={"md"}>
      <Accordion.Item value="advanced" bg={"#fff"} radius={"md"} px={"lg"}>
        <Accordion.Control bg={"#fff"}>
          <Group>
            <IconMessage />
            <Text size="xl" fw={700}>
              {lang.resellers.messages.title}
            </Text>
          </Group>
        </Accordion.Control>
        <Accordion.Panel>
          <Group align="stretch" pos={"relative"}>
            <SegmentedControl
              data={names}
              value={active}
              onChange={setActive}
              orientation="vertical"
              size="lg"
              ta={"left"}
              styles={{
                label: {
                  textAlign: "left",
                  paddingTop: 16,
                  paddingBottom: 16,
                },
              }}
            />

            <ResellersMessagesItem key={active} active={active} />
          </Group>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default ResellerMessages;
